import { Button, CircularProgress } from "@mui/material";
import useStyles from "./index.styles";

interface CreateAccountButtonProps {
  isLoading: boolean;
  onClick: () => void;
  disabled?: boolean;
}

export const CreateAccountButton = ({
  isLoading,
  onClick,
  disabled,
}: CreateAccountButtonProps) => {
  const { classes } = useStyles();

  return (
    <Button
      variant="contained"
      color="primary"
      className={classes.createAccountButton}
      onClick={onClick}
      disabled={disabled || isLoading}
    >
      {isLoading ? (
        <>
          <CircularProgress
            size={15}
            sx={{ color: "white", marginRight: "4px" }}
          />
          <>Creating</>
        </>
      ) : (
        <>Create account</>
      )}
    </Button>
  );
};
